<template>
  <div class="ba-card ba-w-100 ba-flex ba-gp-1 ba-f-column">
    <div class="ba-top">
      <div class="ba-title">
        <span>{{ t.tags }}</span>
        <builderall-icon code="help" class="ba6-info-section" ba-tooltip-position="bottom" ba-tooltip-color="dark" :ba-tooltip-title="t.tags_description"></builderall-icon>
      </div>
      <div class="ba-box-items ba-flex ba-gp-1">
        <button :class="['ba-btn', 'ba-sm', 'ba-blue', loadingTags ? 'ba-disabled' : '']" :disabled="loadingTags" @click="saveForm()">{{ t.dns_save }}</button>
      </div>
    </div>
    <div class="ba-content ba-w-100 ba-flex ba-gp-1 ba-f-column">
      <div class="ba-box-input ba-md">
        <div class="ba-info">
          <div class="ba-info-left">
            <label class="ba-label" for="tag_mailingboss_list_uid">{{ t.mb_list }}</label>
          </div>
        </div>
        <input type="text" v-model="tag_mailingboss_list_uid" class="ba-input" :placeholder="t.placeholder_mb" />
      </div>
    </div>
    <div class="ba6-us-main-horizontal-line" />
    <div class="ba-content ba-w-100 ba-flex ba-gp-1 ba-f-column">
      <div class="ba-flex">
        <h4>{{ t.label_registration_data }}</h4>
        <builderall-icon code="help" class="ba6-info-section" ba-tooltip-position="bottom" ba-tooltip-color="dark" :ba-tooltip-title="t.registration_data_description"></builderall-icon>
      </div>
      <div class="ba-flex ba-f-column ba-gp-1 ba-w-100">
        <div class="ba-flex  ba-gp-1 ba-w-100">
          <div class="ba-box-input ba-md ba-flex ba-f-column ba-w-100">
            <div class="ba-info">
              <div class="ba-info-left">
                <label class="ba-label" for="tag_name">{{ t.ush_url_name }}</label>
              </div>
            </div>
            <input type="text" id="tag_name" v-model="tag_name" class="ba-input" :placeholder="t.text_here+ '...'" maxlength="100" />
          </div>
          <div class="ba-box-input ba-md ba-flex ba-f-column ba-w-100">
            <div class="ba-info">
              <div class="ba-info-left">
                <label class="ba-label" for="tag_last_name">{{ t.label_last_name }}</label>
              </div>
            </div>
            <input type="text" id="tag_last_name" v-model="tag_last_name" class="ba-input" :placeholder="t.text_here+ '...'" maxlength="100" />
          </div>
        </div>
        <div class="ba-flex  ba-gp-1 ba-w-100">
          <div class="ba-box-input ba-md ba-flex ba-f-column ba-w-100">
            <div class="ba-info">
              <div class="ba-info-left">
                <label class="ba-label" for="tag_skype">{{ t.label_skype }}</label>
              </div>
            </div>
            <input type="text" id="tag_skype" v-model="tag_skype" class="ba-input" :placeholder="t.text_here+ '...'" maxlength="150" />
          </div>
          <div class="ba-box-input ba-md ba-flex ba-f-column ba-w-100">
            <div class="ba-info">
              <div class="ba-info-left">
                <label class="ba-label" for="tag_wechat">{{ t.label_wechat }}</label>
              </div>
            </div>
            <input type="text" id="tag_wechat" v-model="tag_wechat" class="ba-input" :placeholder="t.text_here+ '...'" maxlength="150" />
          </div>
        </div>
        <div class="ba-flex  ba-gp-1 ba-w-100">
          <div class="ba-box-input ba-md ba-flex ba-f-column ba-w-100">
            <div class="ba-info">
              <div class="ba-info-left">
                <label class="ba-label" for="name">{{ t.phone }}</label>
              </div>
            </div>
            <div class="ba-box-input-with-element ba-md">
              <select v-model="ddi_tag_phone" name="ddi_tag_phone" id="ddi_tag_phone"
                class="ba-bi-element">
                <option v-for="(c, i) in accountInfo.country_codes" :key="i" :value="c.code" v-text="'+' + c.code">
                </option>
              </select>
              <div class='ba-bi-box-input'>
                <input type="tel" id="tag_phone" v-model="tag_phone" :placeholder='t.enter_your_phone_number' />
              </div>
            </div>
          </div>
          <div class="ba-box-input ba-md ba-flex ba-f-column ba-w-100">
            <div class="ba-info">
              <div class="ba-info-left">
                <label class="ba-label" for="name">{{ t.link_generator_whatsapp }}</label>
              </div>
            </div>
            <div class="ba-box-input-with-element ba-md">
              <select v-model="ddi_tag_whatsapp" name="ddi_tag_whatsapp" id="ddi_tag_whatsapp" class="ba-bi-element">
                <option v-for="(c, i) in accountInfo.country_codes" :key="i" :value="c.code" v-text="'+' + c.code">
                </option>
              </select>
              <div class='ba-bi-box-input'>
                <input type="tel" id="tag_whatsapp" v-model="tag_whatsapp" :placeholder='t.enter_your_phone_number' />
              </div>
            </div>
          </div>
        </div>
        <div class="ba-flex  ba-gp-1 ba-w-100">
          <div class="ba-box-input ba-md ba-flex ba-f-column ba-w-100">
            <div class="ba-info">
              <div class="ba-info-left">
                <label class="ba-label" for="tag_url_main_product">{{ t.label_url_main_product }}</label>
              </div>
            </div>
            <input id="tag_url_main_product" :class="['ba-input', !validationUrl.tag_url_main_product ? 'ba-error' : '']" v-model="tag_url_main_product" type="url" :placeholder="t.enter_website" @input="validateUrl('tag_url_main_product', tag_url_main_product)" />
          </div>
          <div class="ba-box-input ba-md ba-flex ba-f-column ba-w-100">
            <div class="ba-info">
              <div class="ba-info-left">
                <label class="ba-label" for="tag_url_divulgation_link">{{ t.office2_home_links }}</label>
              </div>
            </div>
            <input id="tag_url_divulgation_link" class="ba-input" v-model="tag_url_divulgation_link" type="text" :placeholder="t.enter_website" maxlength="255" />
          </div>
        </div>
      </div>
    </div>
    <div class="ba6-us-main-horizontal-line" />
    <div class="ba-content ba-w-100 ba-flex ba-gp-1 ba-f-column">
      <div class="ba-flex">
        <h4>{{ t.additional_urls }}</h4>
        <builderall-icon code="help" class="ba6-info-section" ba-tooltip-position="bottom" ba-tooltip-color="dark" :ba-tooltip-title="t.additional_url_description"></builderall-icon>
      </div>
      <div class="ba-flex ba-f-column ba-gp-1 ba-w-100">
        <div class="ba-flex  ba-gp-1 ba-w-100">
          <div class="ba-box-input ba-md ba-flex ba-f-column ba-w-100">
            <div class="ba-info">
              <div class="ba-info-left">
                <label class="ba-label" for="tag_url_main_product_url0">{{ t.additional_url_1 }}</label>
              </div>
            </div>
            <input id="tag_url_main_product_url0" class="ba-input" v-model="tag_url_main_product_url0" type="tel" :placeholder="t.enter_website" />
          </div>
          <div class="ba-box-input ba-md ba-flex ba-f-column ba-w-100">
            <div class="ba-info">
              <div class="ba-info-left">
                <label class="ba-label" for="tag_url_main_product_url1">{{ t.additional_url_2 }}</label>
              </div>
            </div>
            <input id="tag_url_main_product_url1" class="ba-input" v-model="tag_url_main_product_url1" type="tel" :placeholder="t.enter_website" />
          </div>
        </div>
        <div class="ba-flex  ba-gp-1 ba-w-100">
          <div class="ba-box-input ba-md ba-flex ba-f-column ba-w-100">
            <div class="ba-info">
              <div class="ba-info-left">
                <label class="ba-label" for="tag_url_main_product_url2">{{ t.additional_url_3 }}</label>
              </div>
            </div>
            <input id="tag_url_main_product_url2" class="ba-input" v-model="tag_url_main_product_url2" type="tel" :placeholder="t.enter_website" />
          </div>
          <div class="ba-box-input ba-md ba-flex ba-f-column ba-w-100">
            <div class="ba-info">
              <div class="ba-info-left">
                <label class="ba-label" for="tag_url_main_product_url3">{{ t.additional_url_4 }}</label>
              </div>
            </div>
            <input id="tag_url_main_product_url3" class="ba-input" v-model="tag_url_main_product_url3" type="tel" :placeholder="t.enter_website" />
          </div>
        </div>
        <div class="ba-flex  ba-gp-1 ba-w-100">
          <div class="ba-box-input ba-md ba-flex ba-f-column ba-w-100">
            <div class="ba-info">
              <div class="ba-info-left">
                <label class="ba-label" for="tag_url_main_product_url4">{{ t.additional_url_5 }}</label>
              </div>
            </div>
            <input id="tag_url_main_product_url4" class="ba-input" v-model="tag_url_main_product_url4" type="tel" :placeholder="t.enter_website" />
          </div>
          <div class="ba-box-input ba-md ba-flex ba-f-column ba-w-100">
            <div class="ba-info">
              <div class="ba-info-left">
                <label class="ba-label" for="tag_url_main_product_url5">{{ t.additional_url_6 }}</label>
              </div>
            </div>
            <input id="tag_url_main_product_url5" class="ba-input" v-model="tag_url_main_product_url5" type="tel" :placeholder="t.enter_website" />
          </div>
        </div>
        <div class="ba-flex  ba-gp-1 ba-w-100">
          <div class="ba-box-input ba-md ba-flex ba-f-column ba-w-100">
            <div class="ba-info">
              <div class="ba-info-left">
                <label class="ba-label" for="tag_url_main_product_url6">{{ t.additional_url_7 }}</label>
              </div>
            </div>
            <input id="tag_url_main_product_url6" class="ba-input" v-model="tag_url_main_product_url6" type="tel" :placeholder="t.enter_website" />
          </div>
          <div class="ba-box-input ba-md ba-flex ba-f-column ba-w-100">
            <div class="ba-info">
              <div class="ba-info-left">
                <label class="ba-label" for="tag_url_main_product_url7">{{ t.additional_url_8 }}</label>
              </div>
            </div>
            <input id="tag_url_main_product_url7" class="ba-input" v-model="tag_url_main_product_url7" type="tel" :placeholder="t.enter_website" />
          </div>
        </div>
        <div class="ba-flex  ba-gp-1 ba-w-100">
          <div class="ba-box-input ba-md ba-flex ba-f-column ba-w-100">
            <div class="ba-info">
              <div class="ba-info-left">
                <label class="ba-label" for="tag_url_main_product_url8">{{ t.additional_url_9 }}</label>
              </div>
            </div>
            <input id="tag_url_main_product_url8" class="ba-input" v-model="tag_url_main_product_url8" type="tel" :placeholder="t.enter_website" />
          </div>
          <div class="ba-box-input ba-md ba-flex ba-f-column ba-w-100">
            <div class="ba-info">
              <div class="ba-info-left">
                <label class="ba-label" for="tag_url_main_product_url9">{{ t.additional_url_10 }}</label>
              </div>
            </div>
            <input id="tag_url_main_product_url9" class="ba-input" v-model="tag_url_main_product_url9" type="tel" :placeholder="t.enter_website" />
          </div>
        </div>
      </div>
    </div>
    <div class="ba6-us-main-horizontal-line" />
    <div class="ba-content ba-w-100 ba-flex ba-gp-1 ba-f-column">
      <div class="ba-flex">
        <h4>{{ t.other_data }}</h4>
        <builderall-icon code="help" class="ba6-info-section" ba-tooltip-position="bottom" ba-tooltip-color="dark" :ba-tooltip-title="t.other_data_description"></builderall-icon>
      </div>
      <div class="ba-flex ba-f-column ba-gp-1 ba-w-100">
        <div class="ba-flex  ba-gp-1 ba-w-100">
          <div class="ba-box-input ba-md ba-flex ba-f-column ba-w-100">
            <div class="ba-info">
              <div class="ba-info-left">
                <label class="ba-label" for="tag_mailingboss_from_name">{{ t.mailingboss_from_name }}</label>
              </div>
            </div>
            <input type="text" id="tag_mailingboss_from_name" v-model="tag_mailingboss_from_name" class="ba-input" :placeholder="t.text_here+ '...' " maxlength="100" />
          </div>
          <div class="ba-box-input ba-md ba-flex ba-f-column ba-w-100">
            <div class="ba-info">
              <div class="ba-info-left">
                <label class="ba-label" for="tag_mailingboss_from_email">{{ t.mailingboss_from_email }}</label>
              </div>
            </div>
            <input type="email" id="tag_mailingboss_from_email" v-model="tag_mailingboss_from_email" :class="['ba-input', !validationEmail.tag_mailingboss_from_email ? 'ba-error' : '']" :placeholder="t.text_here +'...' " maxlength="200" @input="validateEmail('tag_mailingboss_from_email', tag_mailingboss_from_email)" />
          </div>
        </div>
        <div class="ba-flex  ba-gp-1 ba-w-100">
          <div class="ba-box-input ba-md ba-flex ba-f-column ba-w-100">
            <div class="ba-info">
              <div class="ba-info-left">
                <label class="ba-label" for="tag_mailingboss_reply_to">{{ t.mailingboss_reply_to }}</label>
              </div>
            </div>
            <input type="email" id="tag_mailingboss_reply_to" v-model="tag_mailingboss_reply_to" :class="['ba-input', !validationEmail.tag_mailingboss_reply_to ? 'ba-error' : '']" :placeholder="t.text_here +'...' " maxlength="200" @input="validateEmail('tag_mailingboss_reply_to', tag_mailingboss_reply_to)" />
          </div>
          <div class="ba-box-input ba-md ba-flex ba-f-column ba-w-100">
            <div class="ba-info">
              <div class="ba-info-left">
                <label class="ba-label" for="tag_facebook_profile">{{ t.facebook_profile }}</label>
              </div>
            </div>
            <input id="tag_facebook_profile" class="ba-input" maxlength="255" v-model="tag_facebook_profile" type="tel" :placeholder="t.enter_website" />
          </div>
        </div>
      </div>
    </div>
    <div class="ba6-us-main-horizontal-line" />
    <div class="ba-content ba-w-100 ba-flex ba-gp-1 ba-f-column">
      <div class="ba-flex">
        <h4 v-text="t.label_address"></h4>
        <builderall-icon code="help" class="ba6-info-section" ba-tooltip-position="bottom" ba-tooltip-color="dark" :ba-tooltip-title="t.address_description"></builderall-icon>
      </div>
      <div class="ba-content ba-w-100 ba-flex ba-gp-1 ba-f-column">
        <div class="ba-flex  ba-gp-1 ba-w-100">
          <div class="ba-box-input ba-md ba-md ba-w-100">
            <div class="ba-info">
              <div class="ba-info-left">
                <label class="ba-label" for="tag_address_type">Type</label>
              </div>
            </div>
            <select class="ba-select ba-md ba6-select" name="tag_address_type" id="tag_address_type" v-model="tag_address_type">
              <option class="ba-bi-element" value="RES">{{ t.label_profile_residence }}</option>
              <option class="ba-bi-element" value="COM">{{ t.label_profile_comercial }}</option>
            </select>
          </div>
          <div class="ba-box-input ba-md ba-flex ba-f-column ba-w-100">
            <div class="ba-info">
              <div class="ba-info-left">
                <label class="ba-label" for="tag_address_postal_code">{{ t.label_zip_code }}</label>
              </div>
            </div>
            <input type="text" id="tag_address_postal_code" v-model="tag_address_postal_code"
              class="ba-input" :placeholder="t.text_here +'...' " maxlength="10" />
          </div>
          <div class="ba-box-input ba-md ba-flex ba-f-column ba-w-100">
            <div class="ba-info">
              <div class="ba-info-left">
                <label class="ba-label" for="tag_address_description">{{ t.label_address }}</label>
              </div>
            </div>
            <input type="text" id="tag_address_description" v-model="tag_address_description"
              class="ba-input" :placeholder="t.text_here +'...' " maxlength="255" />
          </div>
          <div class="ba-box-input ba-md ba-flex ba-f-column ba-w-100">
            <div class="ba-info">
              <div class="ba-info-left">
                <label class="ba-label" for="tag_address_number">{{ t.label_number }}</label>
              </div>
            </div>
            <input type="number" id="tag_address_number" v-model="tag_address_number" class="ba-input"
              :placeholder="t.text_here +'...' " maxlength="10" />
          </div>
        </div>
        <div class="ba-flex  ba-gp-1 ba-w-100">
          <div class="ba-box-input ba-md ba-flex ba-f-column ba-w-100">
            <div class="ba-info">
              <div class="ba-info-left">
                <label class="ba-label" for="tag_address_complement">{{ t.label_address }} 2</label>
              </div>
            </div>
            <input type="text" id="tag_address_complement" v-model="tag_address_complement"
              class="ba-input" :placeholder="t.text_here +'...' " maxlength="100" />
          </div>
          <div class="ba-box-input ba-md ba-flex ba-f-column ba-w-100">
            <div class="ba-info">
              <div class="ba-info-left">
                <label class="ba-label" for="tag_address_district">{{ t.label_district }}</label>
              </div>
            </div>
            <input type="text" id="tag_address_district" v-model="tag_address_district" class="ba-input"
              :placeholder="t.text_here +'...' " maxlength="50" />
          </div>
          <div class="ba-box-input ba-md ba-flex ba-f-column ba-w-100">
            <div class="ba-info">
              <div class="ba-info-left">
                <label class="ba-label" for="tag_address_city">{{ t.city }}</label>
              </div>
            </div>
            <input type="text" id="tag_address_city" v-model="tag_address_city" class="ba-input"
              :placeholder="t.text_here +'...' " maxlength="100" />
          </div>
          <div class="ba-box-input ba-md ba-flex ba-f-column ba-w-100">
            <div class="ba-info">
              <div class="ba-info-left">
                <label class="ba-label" for="tag_address_state" v-text="t.state"></label>
              </div>
            </div>
            <input type="text" id="tag_address_state" v-model="tag_address_state" class="ba-input"
              :placeholder="t.text_here +'...' " maxlength="100" />
          </div>
        </div>
      </div>
    </div>
    <div class="ba6-us-main-horizontal-line" />
    <div class="ba-content ba-w-100 ba-flex ba-gp-1 ba-f-column">
      <div class="ba-flex">
        <h4 v-text="t.extra_settings"></h4>
        <builderall-icon code="help" class="ba6-info-section" ba-tooltip-position="bottom" ba-tooltip-color="dark" :ba-tooltip-title="t.extra_settings_description"></builderall-icon>
      </div>
      <div class="ba-flex ba-f-column ba-gp-1 ba-w-100">
        <div class="ba-flex  ba-gp-1 ba-w-100">
          <div class="ba-box-input ba-md ba-flex ba-f-column ba-w-100">
            <div class="ba-info">
              <div class="ba-info-left">
                <label class="ba-label" for="extra_tag_0">{{ t.extra_tag + ' 0' }} </label>
              </div>
            </div>
            <input type="text" id="extra_tag_0" v-model="extra_tag_0" class="ba-input"
              :placeholder="t.text_here +'...' " />
          </div>
          <div class="ba-box-input ba-md ba-flex ba-f-column ba-w-100">
            <div class="ba-info">
              <div class="ba-info-left">
                <label class="ba-label" for="extra_tag_1">{{ t.extra_tag + ' 1' }} </label>
              </div>
            </div>
            <input type="text" id="extra_tag_1" v-model="extra_tag_1" class="ba-input"
              :placeholder="t.text_here +'...' " />
          </div>
          <div class="ba-box-input ba-md ba-flex ba-f-column ba-w-100">
            <div class="ba-info">
              <div class="ba-info-left">
                <label class="ba-label" for="extra_tag_2">{{ t.extra_tag + ' 2' }} </label>
              </div>
            </div>
            <input type="text" id="extra_tag_2" v-model="extra_tag_2" class="ba-input"
              :placeholder="t.text_here +'...' " />
          </div>
          <div class="ba-box-input ba-md ba-flex ba-f-column ba-w-100">
            <div class="ba-info">
              <div class="ba-info-left">
                <label class="ba-label" for="extra_tag_3">{{ t.extra_tag + ' 3' }} </label>
              </div>
            </div>
            <input type="text" id="extra_tag_3" v-model="extra_tag_3" class="ba-input"
              :placeholder="t.text_here +'...' " />
          </div>
        </div>
        <div class="ba-flex  ba-gp-1 ba-w-100">
          <div class="ba-box-input ba-md ba-flex ba-f-column ba-w-100">
            <div class="ba-info">
              <div class="ba-info-left">
                <label class="ba-label" for="extra_tag_4">{{ t.extra_tag + ' 4' }} </label>
              </div>
            </div>
            <input type="text" id="extra_tag_4" v-model="extra_tag_4" class="ba-input"
              :placeholder="t.text_here +'...' " />
          </div>
          <div class="ba-box-input ba-md ba-flex ba-f-column ba-w-100">
            <div class="ba-info">
              <div class="ba-info-left">
                <label class="ba-label" for="extra_tag_5">{{ t.extra_tag + ' 5' }} </label>
              </div>
            </div>
            <input type="text" id="extra_tag_5" v-model="extra_tag_5" class="ba-input"
              :placeholder="t.text_here +'...' " />
          </div>
          <div class="ba-box-input ba-md ba-flex ba-f-column ba-w-100">
            <div class="ba-info">
              <div class="ba-info-left">
                <label class="ba-label" for="extra_tag_6">{{ t.extra_tag + ' 6' }} </label>
              </div>
            </div>
            <input type="text" id="extra_tag_6" v-model="extra_tag_6" class="ba-input"
              :placeholder="t.text_here +'...' " />
          </div>
          <div class="ba-box-input ba-md ba-flex ba-f-column ba-w-100">
            <div class="ba-info">
              <div class="ba-info-left">
                <label class="ba-label" for="extra_tag_7">{{ t.extra_tag + ' 7' }} </label>
              </div>
            </div>
            <input type="text" id="extra_tag_7" v-model="extra_tag_7" class="ba-input"
              :placeholder="t.text_here +'...' " />
          </div>
        </div>
        <div class="ba-flex  ba-gp-1 ba-w-100">
          <div class="ba-box-input ba-md ba-flex ba-f-column ba-w-100">
            <div class="ba-info">
              <div class="ba-info-left">
                <label class="ba-label" for="extra_tag_8">{{ t.extra_tag + ' 8' }} </label>
              </div>
            </div>
            <input type="text" id="extra_tag_8" v-model="extra_tag_8" class="ba-input"
              :placeholder="t.text_here +'...' " />
          </div>
          <div class="ba-box-input ba-md ba-flex ba-f-column ba-w-100">
            <div class="ba-info">
              <div class="ba-info-left">
                <label class="ba-label" for="extra_tag_9">{{ t.extra_tag + ' 9' }} </label>
              </div>
            </div>
            <input type="text" id="extra_tag_9" v-model="extra_tag_9" class="ba-input"
              :placeholder="t.text_here +'...' " />
          </div>
          <div class="ba-box-input ba-md ba-flex ba-f-column ba-w-100">
            <div class="ba-info">
              <div class="ba-info-left">
                <label class="ba-label" for="extra_tag_10">{{ t.extra_tag + ' 10' }} </label>
              </div>
            </div>
            <input type="text" id="extra_tag_10" v-model="extra_tag_10" class="ba-input"
              :placeholder="t.text_here +'...' " />
          </div>
          <div class="ba-box-input ba-md ba-flex ba-f-column ba-w-100">
            <div class="ba-info">
              <div class="ba-info-left">
                <label class="ba-label" for="extra_tag_11">{{ t.extra_tag + ' 11' }} </label>
              </div>
            </div>
            <input type="text" id="extra_tag_11" v-model="extra_tag_11" class="ba-input"
              :placeholder="t.text_here +'...' " />
          </div>
        </div>
        <div class="ba-flex  ba-gp-1 ba-w-100">
          <div class="ba-box-input ba-md ba-flex ba-f-column ba-w-100">
            <div class="ba-info">
              <div class="ba-info-left">
                <label class="ba-label" for="extra_tag_12">{{ t.extra_tag + ' 12' }} </label>
              </div>
            </div>
            <input type="text" id="extra_tag_12" v-model="extra_tag_12" class="ba-input"
              :placeholder="t.text_here +'...' " />
          </div>
          <div class="ba-box-input ba-md ba-flex ba-f-column ba-w-100">
            <div class="ba-info">
              <div class="ba-info-left">
                <label class="ba-label" for="extra_tag_13">{{ t.extra_tag + ' 13' }} </label>
              </div>
            </div>
            <input type="text" id="extra_tag_13" v-model="extra_tag_13" class="ba-input"
              :placeholder="t.text_here +'...' " />
          </div>
          <div class="ba-box-input ba-md ba-flex ba-f-column ba-w-100">
            <div class="ba-info">
              <div class="ba-info-left">
                <label class="ba-label" for="extra_tag_14">{{ t.extra_tag + ' 14' }} </label>
              </div>
            </div>
            <input type="text" id="extra_tag_14" v-model="extra_tag_14" class="ba-input"
              :placeholder="t.text_here +'...' " />
          </div>
          <div class="ba-box-input ba-md ba-flex ba-f-column ba-w-100">
            <div class="ba-info">
              <div class="ba-info-left">
                <label class="ba-label" for="extra_tag_15">{{ t.extra_tag + ' 15' }} </label>
              </div>
            </div>
            <input type="text" id="extra_tag_15" v-model="extra_tag_15" class="ba-input"
              :placeholder="t.text_here +'...' " />
          </div>
        </div>
        <div class="ba-flex  ba-gp-1 ba-w-100">
          <div class="ba-box-input ba-md ba-flex ba-f-column ba-w-100">
            <div class="ba-info">
              <div class="ba-info-left">
                <label class="ba-label" for="extra_tag_16">{{ t.extra_tag + ' 16' }} </label>
              </div>
            </div>
            <input type="text" id="extra_tag_16" v-model="extra_tag_16" class="ba-input"
              :placeholder="t.text_here +'...' " />
          </div>
          <div class="ba-box-input ba-md ba-flex ba-f-column ba-w-100">
            <div class="ba-info">
              <div class="ba-info-left">
                <label class="ba-label" for="extra_tag_17">{{ t.extra_tag + ' 17' }} </label>
              </div>
            </div>
            <input type="text" id="extra_tag_17" v-model="extra_tag_17" class="ba-input"
              :placeholder="t.text_here +'...' " />
          </div>
          <div class="ba-box-input ba-md ba-flex ba-f-column ba-w-100">
            <div class="ba-info">
              <div class="ba-info-left">
                <label class="ba-label" for="extra_tag_18">{{ t.extra_tag + ' 18' }} </label>
              </div>
            </div>
            <input type="text" id="extra_tag_18" v-model="extra_tag_18" class="ba-input"
              :placeholder="t.text_here +'...' " />
          </div>
          <div class="ba-box-input ba-md ba-flex ba-f-column ba-w-100">
            <div class="ba-info">
              <div class="ba-info-left">
                <label class="ba-label" for="extra_tag_19">{{ t.extra_tag + ' 19' }} </label>
              </div>
            </div>
            <input type="text" id="extra_tag_19" v-model="extra_tag_19" class="ba-input"
              :placeholder="t.text_here +'...' " />
          </div>
        </div>
      </div>
    </div>
    <div class="ba6-us-main-horizontal-line" />
    <div class="ba-content ba-w-100 ba-flex ba-gp-1 ba-f-column">
      <div class="ba-grid">
        <div class="ba-flex">
          <h4>{{ t.label_files }}</h4>
          <builderall-icon code="help" class="ba6-info-section" ba-tooltip-position="bottom" ba-tooltip-color="dark" :ba-tooltip-title="t.files_description"></builderall-icon>
        </div>
        <p class="ba6-p-element">{{ t.label_tag_file_warning }}</p>
      </div>
      <div class="ba6-files-section ba-flex ba-f-column ba-gp-1 ba-w-100">
        <div class="ba-box-input ba-grid ba-flex ba-f-column ba-w-100">
          <div class="ba-info">
            <div class="ba-info-left">
              <label class="ba-label">{{ t.label_file + ' 0' }}</label>
            </div>
          </div>
          <div class="ba6-input-file-box">
            <label v-if="!file_tag_0" class="ba6-label-file" for="file_tag_0">
              <span v-text="this.t.label_click_to_upload"></span>
              <input type="file" accept=".pdf" @change="handleFileChange" id="file_tag_0" />
            </label>
            <input v-else type="text" v-model="file_tag_0" class="ba-input ba-md ba-disabled" disabled />
            <div v-if="file_tag_0" class="ba-flex ba-ai-center ba-gp-06">
              <a :href="file_tag_0" target="_blank" class='ba-btn ba-btn-normal ba-sm ba-rounded'>
                <builderall-icon code='6adb' />
              </a>
              <button class='ba-btn ba-btn-trash ba-sm ba-rounded' @click="deleteFile('file_tag_0')">
                <builderall-icon code='trash' />
              </button>
            </div>
          </div>
        </div>
        <div class="ba-box-input ba-grid ba-flex ba-f-column ba-w-100">
          <div class="ba-info">
            <div class="ba-info-left">
              <label class="ba-label">{{ t.label_file + ' 1' }}</label>
            </div>
          </div>
          <div class="ba6-input-file-box">
            <label v-if="!file_tag_1" class="ba6-label-file" for="file_tag_1">
              <span v-text="this.t.label_click_to_upload"></span>
              <input type="file" accept=".pdf" @change="handleFileChange" id="file_tag_1" />
            </label>
            <input v-else type="text" v-model="file_tag_1" class="ba-input ba-md ba-disabled" disabled />
            <div v-if="file_tag_1" class="ba-flex ba-ai-center ba-gp-06">
              <a :href="file_tag_1" target="_blank" class='ba-btn ba-btn-normal ba-sm ba-rounded'>
                <builderall-icon code='6adb' />
              </a>
              <button class='ba-btn ba-btn-trash ba-sm ba-rounded' @click="deleteFile('file_tag_1')">
                <builderall-icon code='trash' />
              </button>
            </div>
          </div>
        </div>
        <div class="ba-box-input ba-grid ba-flex ba-f-column ba-w-100">
          <div class="ba-info">
            <div class="ba-info-left">
              <label class="ba-label">{{ t.label_file + ' 2' }}</label>
            </div>
          </div>
          <div class="ba6-input-file-box">
            <label v-if="!file_tag_2" class="ba6-label-file" for="file_tag_2">
              <span v-text="this.t.label_click_to_upload"></span>
              <input type="file" accept=".pdf" @change="handleFileChange" id="file_tag_2" />
            </label>
            <input v-else type="text" v-model="file_tag_2" class="ba-input ba-md ba-disabled" disabled />
            <div v-if="file_tag_2" class="ba-flex ba-ai-center ba-gp-06">
              <a :href="file_tag_2" target="_blank" class='ba-btn ba-btn-normal ba-sm ba-rounded'>
                <builderall-icon code='6adb' />
              </a>
              <button class='ba-btn ba-btn-trash ba-sm ba-rounded' @click="deleteFile('file_tag_2')">
                <builderall-icon code='trash' />
              </button>
            </div>
          </div>
        </div>
        <div class="ba-box-input ba-grid ba-flex ba-f-column ba-w-100">
          <div class="ba-info">
            <div class="ba-info-left">
              <label class="ba-label">{{ t.label_file + ' 3' }}</label>
            </div>
          </div>
          <div class="ba6-input-file-box">
            <label v-if="!file_tag_3" class="ba6-label-file" for="file_tag_3">
              <span v-text="this.t.label_click_to_upload"></span>
              <input type="file" accept=".pdf" @change="handleFileChange" id="file_tag_3" />
            </label>
            <input v-else type="text" v-model="file_tag_3" class="ba-input ba-md ba-disabled" disabled />
            <div v-if="file_tag_3" class="ba-flex ba-ai-center ba-gp-06">
              <a :href="file_tag_3" target="_blank" class='ba-btn ba-btn-normal ba-sm ba-rounded'>
                <builderall-icon code='6adb' />
              </a>
              <button class='ba-btn ba-btn-trash ba-sm ba-rounded' @click="deleteFile('file_tag_3')">
                <builderall-icon code='trash' />
              </button>
            </div>
          </div>
        </div>
        <div class="ba-box-input ba-grid ba-flex ba-f-column ba-w-100">
          <div class="ba-info">
            <div class="ba-info-left">
              <label class="ba-label">{{ t.label_file + ' 4' }}</label>
            </div>
          </div>
          <div class="ba6-input-file-box">
            <label v-if="!file_tag_4" class="ba6-label-file" for="file_tag_4">
              <span v-text="this.t.label_click_to_upload"></span>
              <input type="file" accept=".pdf" @change="handleFileChange" id="file_tag_4" />
            </label>
            <input v-else type="text" v-model="file_tag_4" class="ba-input ba-md ba-disabled" disabled />
            <div v-if="file_tag_4" class="ba-flex ba-ai-center ba-gp-06">
              <a :href="file_tag_4" target="_blank" class='ba-btn ba-btn-normal ba-sm ba-rounded'>
                <builderall-icon code='6adb' />
              </a>
              <button class='ba-btn ba-btn-trash ba-sm ba-rounded' @click="deleteFile('file_tag_4')">
                <builderall-icon code='trash' />
              </button>
            </div>
          </div>
        </div>
        <div class="ba-box-input ba-grid ba-flex ba-f-column ba-w-100">
          <div class="ba-info">
            <div class="ba-info-left">
              <label class="ba-label">{{ t.label_file + ' 5' }}</label>
            </div>
          </div>
          <div class="ba6-input-file-box">
            <label v-if="!file_tag_5" class="ba6-label-file" for="file_tag_5">
              <span v-text="this.t.label_click_to_upload"></span>
              <input type="file" accept=".pdf" @change="handleFileChange" id="file_tag_5" />
            </label>
            <input v-else type="text" v-model="file_tag_5" class="ba-input ba-md ba-disabled" disabled />
            <div v-if="file_tag_5" class="ba-flex ba-ai-center ba-gp-06">
              <a :href="file_tag_5" target="_blank" class='ba-btn ba-btn-normal ba-sm ba-rounded'>
                <builderall-icon code='6adb' />
              </a>
              <button class='ba-btn ba-btn-trash ba-sm ba-rounded' @click="deleteFile('file_tag_5')">
                <builderall-icon code='trash' />
              </button>
            </div>
          </div>
        </div>
        <div class="ba-box-input ba-grid ba-flex ba-f-column ba-w-100">
          <div class="ba-info">
            <div class="ba-info-left">
              <label class="ba-label">{{ t.label_file + ' 6' }}</label>
            </div>
          </div>
          <div class="ba6-input-file-box">
            <label v-if="!file_tag_6" class="ba6-label-file" for="file_tag_6">
              <span v-text="this.t.label_click_to_upload"></span>
              <input type="file" accept=".pdf" @change="handleFileChange" id="file_tag_6" />
            </label>
            <input v-else type="text" v-model="file_tag_6" class="ba-input ba-md ba-disabled" disabled />
            <div v-if="file_tag_6" class="ba-flex ba-ai-center ba-gp-06">
              <a :href="file_tag_6" target="_blank" class='ba-btn ba-btn-normal ba-sm ba-rounded'>
                <builderall-icon code='6adb' />
              </a>
              <button class='ba-btn ba-btn-trash ba-sm ba-rounded' @click="deleteFile('file_tag_6')">
                <builderall-icon code='trash' />
              </button>
            </div>
          </div>
        </div>
        <div class="ba-box-input ba-grid ba-flex ba-f-column ba-w-100">
          <div class="ba-info">
            <div class="ba-info-left">
              <label class="ba-label">{{ t.label_file + ' 7' }}</label>
            </div>
          </div>
          <div class="ba6-input-file-box">
            <label v-if="!file_tag_7" class="ba6-label-file" for="file_tag_7">
              <span v-text="this.t.label_click_to_upload"></span>
              <input type="file" accept=".pdf" @change="handleFileChange" id="file_tag_7" />
            </label>
            <input v-else type="text" v-model="file_tag_7" class="ba-input ba-md ba-disabled" disabled />
            <div v-if="file_tag_7" class="ba-flex ba-ai-center ba-gp-06">
              <a :href="file_tag_7" target="_blank" class='ba-btn ba-btn-normal ba-sm ba-rounded'>
                <builderall-icon code='6adb' />
              </a>
              <button class='ba-btn ba-btn-trash ba-sm ba-rounded' @click="deleteFile('file_tag_7')">
                <builderall-icon code='trash' />
              </button>
            </div>
          </div>
        </div>
        <div class="ba-box-input ba-grid ba-flex ba-f-column ba-w-100">
          <div class="ba-info">
            <div class="ba-info-left">
              <label class="ba-label">{{ t.label_file + ' 8' }}</label>
            </div>
          </div>
          <div class="ba6-input-file-box">
            <label v-if="!file_tag_8" class="ba6-label-file" for="file_tag_8">
              <span v-text="this.t.label_click_to_upload"></span>
              <input type="file" accept=".pdf" @change="handleFileChange" id="file_tag_8" />
            </label>
            <input v-else type="text" v-model="file_tag_8" class="ba-input ba-md ba-disabled" disabled />
            <div v-if="file_tag_8" class="ba-flex ba-ai-center ba-gp-06">
              <a :href="file_tag_8" target="_blank" class='ba-btn ba-btn-normal ba-sm ba-rounded'>
                <builderall-icon code='6adb' />
              </a>
              <button class='ba-btn ba-btn-trash ba-sm ba-rounded' @click="deleteFile('file_tag_8')">
                <builderall-icon code='trash' />
              </button>
            </div>
          </div>
        </div>
        <div class="ba-box-input ba-grid ba-flex ba-f-column ba-w-100">
          <div class="ba-info">
            <div class="ba-info-left">
              <label class="ba-label">{{ t.label_file + ' 9' }}</label>
            </div>
          </div>
          <div class="ba6-input-file-box">
            <label v-if="!file_tag_9" class="ba6-label-file" for="file_tag_9">
              <span v-text="this.t.label_click_to_upload"></span>
              <input type="file" accept=".pdf" @change="handleFileChange" id="file_tag_9" />
            </label>
            <input v-else type="text" v-model="file_tag_9" class="ba-input ba-md ba-disabled" disabled />
            <div v-if="file_tag_9" class="ba-flex ba-ai-center ba-gp-06">
              <a :href="file_tag_9" target="_blank" class='ba-btn ba-btn-normal ba-sm ba-rounded'>
                <builderall-icon code='6adb' />
              </a>
              <button class='ba-btn ba-btn-trash ba-sm ba-rounded' @click="deleteFile('file_tag_9')">
                <builderall-icon code='trash' />
              </button>
            </div>
          </div>
        </div>
        <div class="ba-box-input ba-grid ba-flex ba-f-column ba-w-100">
          <div class="ba-info">
            <div class="ba-info-left">
              <label class="ba-label">{{ t.label_file + ' 10' }}</label>
            </div>
          </div>
          <div class="ba6-input-file-box">
            <label v-if="!file_tag_10" class="ba6-label-file" for="file_tag_10">
              <span v-text="this.t.label_click_to_upload"></span>
              <input type="file" accept=".pdf" @change="handleFileChange" id="file_tag_10" />
            </label>
            <input v-else type="text" v-model="file_tag_10" class="ba-input ba-md ba-disabled" disabled />
            <div v-if="file_tag_10" class="ba-flex ba-ai-center ba-gp-06">
              <a :href="file_tag_10" target="_blank" class='ba-btn ba-btn-normal ba-sm ba-rounded'>
                <builderall-icon code='6adb' />
              </a>
              <button class='ba-btn ba-btn-trash ba-sm ba-rounded' @click="deleteFile('file_tag_10')">
                <builderall-icon code='trash' />
              </button>
            </div>
          </div>
        </div>
        <div class="ba-box-input ba-grid ba-flex ba-f-column ba-w-100">
          <div class="ba-info">
            <div class="ba-info-left">
              <label class="ba-label">{{ t.label_file + ' 11' }}</label>
            </div>
          </div>
          <div class="ba6-input-file-box">
            <label v-if="!file_tag_11" class="ba6-label-file" for="file_tag_11">
              <span v-text="this.t.label_click_to_upload"></span>
              <input type="file" accept=".pdf" @change="handleFileChange" id="file_tag_11" />
            </label>
            <input v-else type="text" v-model="file_tag_11" class="ba-input ba-md ba-disabled" disabled />
            <div v-if="file_tag_11" class="ba-flex ba-ai-center ba-gp-06">
              <a :href="file_tag_11" target="_blank" class='ba-btn ba-btn-normal ba-sm ba-rounded'>
                <builderall-icon code='6adb' />
              </a>
              <button class='ba-btn ba-btn-trash ba-sm ba-rounded' @click="deleteFile('file_tag_11')">
                <builderall-icon code='trash' />
              </button>
            </div>
          </div>
        </div>
        <div class="ba-box-input ba-grid ba-flex ba-f-column ba-w-100">
          <div class="ba-info">
            <div class="ba-info-left">
              <label class="ba-label">{{ t.label_file + ' 12' }}</label>
            </div>
          </div>
          <div class="ba6-input-file-box">
            <label v-if="!file_tag_12" class="ba6-label-file" for="file_tag_12">
              <span v-text="this.t.label_click_to_upload"></span>
              <input type="file" accept=".pdf" @change="handleFileChange" id="file_tag_12" />
            </label>
            <input v-else type="text" v-model="file_tag_12" class="ba-input ba-md ba-disabled" disabled />
            <div v-if="file_tag_12" class="ba-flex ba-ai-center ba-gp-06">
              <a :href="file_tag_12" target="_blank" class='ba-btn ba-btn-normal ba-sm ba-rounded'>
                <builderall-icon code='6adb' />
              </a>
              <button class='ba-btn ba-btn-trash ba-sm ba-rounded' @click="deleteFile('file_tag_12')">
                <builderall-icon code='trash' />
              </button>
            </div>
          </div>
        </div>
        <div class="ba-box-input ba-grid ba-flex ba-f-column ba-w-100">
          <div class="ba-info">
            <div class="ba-info-left">
              <label class="ba-label">{{ t.label_file + ' 13' }}</label>
            </div>
          </div>
          <div class="ba6-input-file-box">
            <label v-if="!file_tag_13" class="ba6-label-file" for="file_tag_13">
              <span v-text="this.t.label_click_to_upload"></span>
              <input type="file" accept=".pdf" @change="handleFileChange" id="file_tag_13" />
            </label>
            <input v-else type="text" v-model="file_tag_13" class="ba-input ba-md ba-disabled" disabled />
            <div v-if="file_tag_13" class="ba-flex ba-ai-center ba-gp-06">
              <a :href="file_tag_13" target="_blank" class='ba-btn ba-btn-normal ba-sm ba-rounded'>
                <builderall-icon code='6adb' />
              </a>
              <button class='ba-btn ba-btn-trash ba-sm ba-rounded' @click="deleteFile('file_tag_13')">
                <builderall-icon code='trash' />
              </button>
            </div>
          </div>
        </div>
        <div class="ba-box-input ba-grid ba-flex ba-f-column ba-w-100">
          <div class="ba-info">
            <div class="ba-info-left">
              <label class="ba-label">{{ t.label_file + ' 14' }}</label>
            </div>
          </div>
          <div class="ba6-input-file-box">
            <label v-if="!file_tag_14" class="ba6-label-file" for="file_tag_14">
              <span v-text="this.t.label_click_to_upload"></span>
              <input type="file" accept=".pdf" @change="handleFileChange" id="file_tag_14" />
            </label>
            <input v-else type="text" v-model="file_tag_14" class="ba-input ba-md ba-disabled" disabled />
            <div v-if="file_tag_14" class="ba-flex ba-ai-center ba-gp-06">
              <a :href="file_tag_14" target="_blank" class='ba-btn ba-btn-normal ba-sm ba-rounded'>
                <builderall-icon code='6adb' />
              </a>
              <button class='ba-btn ba-btn-trash ba-sm ba-rounded' @click="deleteFile('file_tag_14')">
                <builderall-icon code='trash' />
              </button>
            </div>
          </div>
        </div>
        <div class="ba-box-input ba-grid ba-flex ba-f-column ba-w-100">
          <div class="ba-info">
            <div class="ba-info-left">
              <label class="ba-label">{{ t.label_file + ' 15' }}</label>
            </div>
          </div>
          <div class="ba6-input-file-box">
            <label v-if="!file_tag_15" class="ba6-label-file" for="file_tag_15">
              <span v-text="this.t.label_click_to_upload"></span>
              <input type="file" accept=".pdf" @change="handleFileChange" id="file_tag_15" />
            </label>
            <input v-else type="text" v-model="file_tag_15" class="ba-input ba-md ba-disabled" disabled />
            <div v-if="file_tag_15" class="ba-flex ba-ai-center ba-gp-06">
              <a :href="file_tag_15" target="_blank" class='ba-btn ba-btn-normal ba-sm ba-rounded'>
                <builderall-icon code='6adb' />
              </a>
              <button class='ba-btn ba-btn-trash ba-sm ba-rounded' @click="deleteFile('file_tag_15')">
                <builderall-icon code='trash' />
              </button>
            </div>
          </div>
        </div>
        <div class="ba-box-input ba-grid ba-flex ba-f-column ba-w-100">
          <div class="ba-info">
            <div class="ba-info-left">
              <label class="ba-label">{{ t.label_file + ' 16' }}</label>
            </div>
          </div>
          <div class="ba6-input-file-box">
            <label v-if="!file_tag_16" class="ba6-label-file" for="file_tag_16">
              <span v-text="this.t.label_click_to_upload"></span>
              <input type="file" accept=".pdf" @change="handleFileChange" id="file_tag_16" />
            </label>
            <input v-else type="text" v-model="file_tag_16" class="ba-input ba-md ba-disabled" disabled />
            <div v-if="file_tag_16" class="ba-flex ba-ai-center ba-gp-06">
              <a :href="file_tag_16" target="_blank" class='ba-btn ba-btn-normal ba-sm ba-rounded'>
                <builderall-icon code='6adb' />
              </a>
              <button class='ba-btn ba-btn-trash ba-sm ba-rounded' @click="deleteFile('file_tag_16')">
                <builderall-icon code='trash' />
              </button>
            </div>
          </div>
        </div>
        <div class="ba-box-input ba-grid ba-flex ba-f-column ba-w-100">
          <div class="ba-info">
            <div class="ba-info-left">
              <label class="ba-label">{{ t.label_file + ' 17' }}</label>
            </div>
          </div>
          <div class="ba6-input-file-box">
            <label v-if="!file_tag_17" class="ba6-label-file" for="file_tag_17">
              <span v-text="this.t.label_click_to_upload"></span>
              <input type="file" accept=".pdf" @change="handleFileChange" id="file_tag_17" />
            </label>
            <input v-else type="text" v-model="file_tag_17" class="ba-input ba-md ba-disabled" disabled />
            <div v-if="file_tag_17" class="ba-flex ba-ai-center ba-gp-06">
              <a :href="file_tag_17" target="_blank" class='ba-btn ba-btn-normal ba-sm ba-rounded'>
                <builderall-icon code='6adb' />
              </a>
              <button class='ba-btn ba-btn-trash ba-sm ba-rounded' @click="deleteFile('file_tag_17')">
                <builderall-icon code='trash' />
              </button>
            </div>
          </div>
        </div>
        <div class="ba-box-input ba-grid ba-flex ba-f-column ba-w-100">
          <div class="ba-info">
            <div class="ba-info-left">
              <label class="ba-label">{{ t.label_file + ' 18' }}</label>
            </div>
          </div>
          <div class="ba6-input-file-box">
            <label v-if="!file_tag_18" class="ba6-label-file" for="file_tag_18">
              <span v-text="this.t.label_click_to_upload"></span>
              <input type="file" accept=".pdf" @change="handleFileChange" id="file_tag_18" />
            </label>
            <input v-else type="text" v-model="file_tag_18" class="ba-input ba-md ba-disabled" disabled />
            <div v-if="file_tag_18" class="ba-flex ba-ai-center ba-gp-06">
              <a :href="file_tag_18" target="_blank" class='ba-btn ba-btn-normal ba-sm ba-rounded'>
                <builderall-icon code='6adb' />
              </a>
              <button class='ba-btn ba-btn-trash ba-sm ba-rounded' @click="deleteFile('file_tag_18')">
                <builderall-icon code='trash' />
              </button>
            </div>
          </div>
        </div>
        <div class="ba-box-input ba-grid ba-flex ba-f-column ba-w-100">
          <div class="ba-info">
            <div class="ba-info-left">
              <label class="ba-label">{{ t.label_file + ' 19' }}</label>
            </div>
          </div>
          <div class="ba6-input-file-box">
            <label v-if="!file_tag_19" class="ba6-label-file" for="file_tag_19">
              <span v-text="this.t.label_click_to_upload"></span>
              <input type="file" accept=".pdf" @change="handleFileChange" id="file_tag_19" />
            </label>
            <input v-else type="text" v-model="file_tag_19" class="ba-input ba-md ba-disabled" disabled />
            <div v-if="file_tag_19" class="ba-flex ba-ai-center ba-gp-06">
              <a :href="file_tag_19" target="_blank" class='ba-btn ba-btn-normal ba-sm ba-rounded'>
                <builderall-icon code='6adb' />
              </a>
              <button class='ba-btn ba-btn-trash ba-sm ba-rounded' @click="deleteFile('file_tag_19')">
                <builderall-icon code='trash' />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ba6-mailingboss",
  props: ['routes','accountInfo','mb','t'],
  data() {
    return {
      loadingTags: false,
      // Registration data
      tag_mailingboss_list_uid: this.mb.tag_mailingboss_list_uid,
      tag_name: this.mb.tag_name,
      tag_last_name: this.mb.tag_last_name,
      tag_skype: this.mb.tag_skype,
      tag_wechat: this.mb.tag_wechat,
      ddi_tag_phone: this.mb.ddi_tag_phone,
      tag_phone: this.mb.tag_phone,
      ddi_tag_whatsapp: this.mb.ddi_tag_whatsapp,
      tag_whatsapp: this.mb.tag_whatsapp,
      tag_url_main_product: this.mb.tag_url_main_product,
      tag_url_divulgation_link: this.mb.tag_url_divulgation_link,
      // Additional URL
      tag_url_main_product_url0: this.mb.tag_url_main_product_url0,
      tag_url_main_product_url1: this.mb.tag_url_main_product_url1,
      tag_url_main_product_url2: this.mb.tag_url_main_product_url2,
      tag_url_main_product_url3: this.mb.tag_url_main_product_url3,
      tag_url_main_product_url4: this.mb.tag_url_main_product_url4,
      tag_url_main_product_url5: this.mb.tag_url_main_product_url5,
      tag_url_main_product_url6: this.mb.tag_url_main_product_url6,
      tag_url_main_product_url7: this.mb.tag_url_main_product_url7,
      tag_url_main_product_url8: this.mb.tag_url_main_product_url8,
      tag_url_main_product_url9: this.mb.tag_url_main_product_url9,
      // Other Data
      tag_mailingboss_from_name: this.mb.tag_mailingboss_from_name,
      tag_mailingboss_from_email: this.mb.tag_mailingboss_from_email,
      tag_mailingboss_reply_to: this.mb.tag_mailingboss_reply_to,
      tag_facebook_profile: this.mb.tag_facebook_profile,
      // Address
      tag_address_type: this.mb.tag_address_type,
      tag_address_postal_code: this.mb.tag_address_postal_code,
      tag_address_description: this.mb.tag_address_description,
      tag_address_number: this.mb.tag_address_number,
      tag_address_complement: this.mb.tag_address_complement,
      tag_address_district: this.mb.tag_address_district,
      tag_address_city: this.mb.tag_address_city,
      tag_address_state: this.mb.tag_address_state,
      // Extra Settings 
      extra_tag_0: this.mb.extra_tag_0,
      extra_tag_1: this.mb.extra_tag_1,
      extra_tag_2: this.mb.extra_tag_2,
      extra_tag_3: this.mb.extra_tag_3,
      extra_tag_4: this.mb.extra_tag_4,
      extra_tag_5: this.mb.extra_tag_5,
      extra_tag_6: this.mb.extra_tag_6,
      extra_tag_7: this.mb.extra_tag_7,
      extra_tag_8: this.mb.extra_tag_8,
      extra_tag_9: this.mb.extra_tag_9,
      extra_tag_10: this.mb.extra_tag_10,
      extra_tag_11: this.mb.extra_tag_11,
      extra_tag_12: this.mb.extra_tag_12,
      extra_tag_13: this.mb.extra_tag_13,
      extra_tag_14: this.mb.extra_tag_14,
      extra_tag_15: this.mb.extra_tag_15,
      extra_tag_16: this.mb.extra_tag_16,
      extra_tag_17: this.mb.extra_tag_17,
      extra_tag_18: this.mb.extra_tag_18,
      extra_tag_19: this.mb.extra_tag_19,
      // Files
      file_tag_0: this.mb.file_tag_0,
      file_tag_1: this.mb.file_tag_1,
      file_tag_2: this.mb.file_tag_2,
      file_tag_3: this.mb.file_tag_3,
      file_tag_4: this.mb.file_tag_4,
      file_tag_5: this.mb.file_tag_5,
      file_tag_6: this.mb.file_tag_6,
      file_tag_7: this.mb.file_tag_7,
      file_tag_8: this.mb.file_tag_8,
      file_tag_9: this.mb.file_tag_9,
      file_tag_10: this.mb.file_tag_10,
      file_tag_11: this.mb.file_tag_11,
      file_tag_12: this.mb.file_tag_12,
      file_tag_13: this.mb.file_tag_13,
      file_tag_14: this.mb.file_tag_14,
      file_tag_15: this.mb.file_tag_15,
      file_tag_16: this.mb.file_tag_16,
      file_tag_17: this.mb.file_tag_17,
      file_tag_18: this.mb.file_tag_18,
      file_tag_19: this.mb.file_tag_19,
      // Validation
      validationUrl:{
        tag_url_main_product: true,
      },
      validationEmail:{
        tag_mailingboss_from_email: true,
        tag_mailingboss_reply_to: true
      }
    };
  },
  mounted(){
    // Validate URLs
    this.validateUrl('tag_url_main_product',      this.tag_url_main_product);

    // Validate Emails
    this.validateEmail('tag_mailingboss_from_email', this.tag_mailingboss_from_email);
    this.validateEmail('tag_mailingboss_reply_to',   this.tag_mailingboss_reply_to);
  },
  methods: {
    validateUrl(data, value){
      const regexURL = /^(https?:\/\/)?([a-zA-Z0-9-]+\.){1,}[a-zA-Z]{2,}(:[0-9]{1,})?(\/.*)?$/;
      this.validationUrl[data] = regexURL.test(value) || !value;
    },
    validateEmail(data, value){
      const regexEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      this.validationEmail[data] = regexEmail.test(value) || !value;
    },
    validateAll(){
      const hasFalseInValidationUrl = Object.values(this.validationUrl).some(v => v === false);
      const hasFalseInValidationEmail = Object.values(this.validationEmail).some(v => v === false);

      if(hasFalseInValidationUrl || hasFalseInValidationEmail)
      {
        return false;
      }
      return true;
    },
    saveForm(){
      if(this.validateAll())
      {
        this.loadingTags = true;
                  
        const formData = new FormData();
        // Registration data
        formData.append('tag_mailingboss_list_uid', this.tag_mailingboss_list_uid);
        formData.append('tag_name', this.tag_name);
        formData.append('tag_last_name', this.tag_last_name);
        formData.append('tag_skype', this.tag_skype);
        formData.append('tag_wechat', this.tag_wechat);
        formData.append('ddi_tag_phone', this.ddi_tag_phone);
        formData.append('tag_phone', this.tag_phone);
        formData.append('ddi_tag_whatsapp', this.ddi_tag_whatsapp);
        formData.append('tag_whatsapp', this.tag_whatsapp);
        formData.append('tag_url_main_product', this.tag_url_main_product);
        formData.append('tag_url_divulgation_link', this.tag_url_divulgation_link);
        // Additional URL
        formData.append('tag_url_main_product_url[]', this.tag_url_main_product_url0);
        formData.append('tag_url_main_product_url[]', this.tag_url_main_product_url1);
        formData.append('tag_url_main_product_url[]', this.tag_url_main_product_url2);
        formData.append('tag_url_main_product_url[]', this.tag_url_main_product_url3);
        formData.append('tag_url_main_product_url[]', this.tag_url_main_product_url4);
        formData.append('tag_url_main_product_url[]', this.tag_url_main_product_url5);
        formData.append('tag_url_main_product_url[]', this.tag_url_main_product_url6);
        formData.append('tag_url_main_product_url[]', this.tag_url_main_product_url7);
        formData.append('tag_url_main_product_url[]', this.tag_url_main_product_url8);
        formData.append('tag_url_main_product_url[]', this.tag_url_main_product_url9);
        // Other Data
        formData.append('tag_mailingboss_from_name', this.tag_mailingboss_from_name);
        formData.append('tag_mailingboss_from_email', this.tag_mailingboss_from_email);
        formData.append('tag_mailingboss_reply_to', this.tag_mailingboss_reply_to);
        formData.append('tag_facebook_profile', this.tag_facebook_profile);
        // Address
        formData.append('tag_address_type', this.tag_address_type);
        formData.append('tag_address_postal_code', this.tag_address_postal_code);
        formData.append('tag_address_description', this.tag_address_description);
        formData.append('tag_address_number', this.tag_address_number);
        formData.append('tag_address_complement', this.tag_address_complement);
        formData.append('tag_address_district', this.tag_address_district);
        formData.append('tag_address_city', this.tag_address_city);
        formData.append('tag_address_state', this.tag_address_state);
        // Extra Settings 
        formData.append('extra_tags[]', this.extra_tag_0);
        formData.append('extra_tags[]', this.extra_tag_1);
        formData.append('extra_tags[]', this.extra_tag_2);
        formData.append('extra_tags[]', this.extra_tag_3);
        formData.append('extra_tags[]', this.extra_tag_4);
        formData.append('extra_tags[]', this.extra_tag_5);
        formData.append('extra_tags[]', this.extra_tag_6);
        formData.append('extra_tags[]', this.extra_tag_7);
        formData.append('extra_tags[]', this.extra_tag_8);
        formData.append('extra_tags[]', this.extra_tag_9);
        formData.append('extra_tags[]', this.extra_tag_10);
        formData.append('extra_tags[]', this.extra_tag_11);
        formData.append('extra_tags[]', this.extra_tag_12);
        formData.append('extra_tags[]', this.extra_tag_13);
        formData.append('extra_tags[]', this.extra_tag_14);
        formData.append('extra_tags[]', this.extra_tag_15);
        formData.append('extra_tags[]', this.extra_tag_16);
        formData.append('extra_tags[]', this.extra_tag_17);
        formData.append('extra_tags[]', this.extra_tag_18);
        formData.append('extra_tags[]', this.extra_tag_19);
  
        formData.append('is_ba6_profile_refactor', true);
  
        axios
          .post(this.routes.route_office_save_tags, formData)
          .then((response) => {
            if(response.data.success)
            {
              alertMsg('success', response.data.msg);
            }
            else
            {
              alertMsg('error', this.t.error_when_saving);
            }
          })
          .catch((error) => {
            console.error('Error to save MailingBoss geral data', error.message);
          })
          .finally(() => {
            this.loadingTags = false
          })
      }
      else
      {
        alertMsg('error', this.t.complete_correctly_fields);
      }
    },
    handleFileChange(event){
      const fileInput = event.target;
      const file = fileInput.files[0];
      let hasError = false;

      if(!file)
      {
        alertMsg('error', this.t.please_select_a_file);
        hasError = true;
      }

      if(!file.name.toLowerCase().endsWith('.pdf') || file.size > 3000000)
      {
        alertMsg('error', this.t.label_tag_file_warning);
        hasError = true;
      }

      if(hasError)
      {
        fileInput['value'] = null;
        fileInput['type'] = 'file';
        return;
      }

      const formData = new FormData();
      formData.append(fileInput['id'], file);

      axios
        .post(this.routes.route_office_save_tags_upload_file, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((response) => {
          if(response.data.success)
          {
            alertMsg('success', this.t.successfully_uploaded);
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
        })
        .catch((error) => {
          console.error('Error to upload file', error.message);
        })
        .finally(() => {
          this.loading = false
        })
    },
    deleteFile(data){
      let confirmResult = confirm(this.t.are_you_sure_delete_this_file);

      if(confirmResult)
      {
        axios
          .post(this.routes.route_office_save_tags_clear_file+'/'+data)
          .then((response) => {
            alertMsg('success', this.t.successfully_deleted);
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          })
          .catch((error) => {
            console.error('Error to remove file', error.message);
          })
          .finally(() => {
            this.loading = false
          })
      }
    }
  }
};
</script>


<style scoped lang="scss">
.ba6-us-main-horizontal-line {
  background-color: #c4d1e0;
  width: 100%;
  height: 1px;
}

.ba6-info-section{
  --builderall-icon-size: 22px;
  --builderall-icon-color: #0072e1;
  padding: 0px 5px 6px 7px;
}

.ba6-select {
  height: 42px;
}
.ba6-p-element{
  color: #4D5D71;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.66px;
}
.ba6-input-file-box{
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 1rem;
  .ba6-label-file{
    cursor: pointer;
    border-radius: 6px;
    background: #EFF2F8;
    margin: 0;
    padding: 9.6px 12.8px;
    span{
      font-size: 14px;
      font-weight: 400;
    }
  }
  input[type="file"]{
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/office-v6/account-settings/routes/Mailingboss.vue